module.exports = __webpack_public_path__ + "static/media/Portrait-Icon.ac0cc64d.gif";